import script from "./ProfilePage.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfilePage.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/profile.css?vue&type=style&index=0&lang=css&external"

const __exports__ = script;

export default __exports__